interface ISiteLabelDecimalConfig
    extends ISiteLabelConfig {
    
    readOnly?: boolean;
    
    minValue?: number;
    maxValue?: number;
    decimals: number;
    showDecimals?: number;

    salesUnitProperty?: string;

    quantityProperty?: string;
    quantityArray?: {[a:number]: number};

    priceProperty?: string;
    originalPriceProperty?: string;
    priceQuantity?: {
        multiplier: number;
        price: number;
    };
}

interface ISiteLabelDecimalSalesUnits
{
    salesUnits: SalesUnit[];
    salesUnitNames: {[key: string]: string}
}

class SiteLabelDecimal
    extends SiteLabel<number, ISiteLabelDecimalConfig> {

    private _changedPriceEvent?: (data: ISiteModelValueChanged) => void;
    private _changedQuantityEvent?: (data: ISiteModelValueChanged) => void;
    private _changedSalesUnitEvent?: (data: ISiteModelValueChanged) => void;
    private _input: IQueryElement;
    private _container: IQueryElement;
    private _startValue: number | null = null;
    private _salesUnits: ISiteLabelDecimalSalesUnits | null = null;
    private _salesUnit: SalesUnit;
    private static SALESUNIT_DEFAULT : SalesUnit = {
        quantity: 1,
        salesUnit: "Piece"
    }
    private _origValue: number | null = null;
    private _percentage: IQueryElement | null;
    private _lastPrice: number | null = null;
    private _originalPrice: number | null = null;

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel, element: HTMLElement) {
        super(card, model, modelData, element);

        let input = this.query("input").first();

        if(input === null)
            throw 'SiteLabelDecimal: Missing element(s)';

        this._input = input;
        this._input.setAttr("type", "number");
        this._input.setAttr("inputmode", "decimal");
        this._input.addClass("no-spinner");
        this._input.on("wheel", (e) => {
            e.stop();
        });
        
        this._percentage = this.query(".percentage").first();
        this._salesUnit = SiteLabelDecimal.SALESUNIT_DEFAULT;

        // if (Site.isMobile && !Site.hasKeyboard())
           //this._input.setAttr("readonly", "true");
        if (this.config.readOnly == true)
        {
            this._input.setAttr("readonly", "true");
            this.config.popout = "none";
        }

        if (this.config.readOnly != true)
        {
            let icon = this.getIcon();
            icon && icon.on("click", () => { this.showToggle(); });

            let backspace = this.query("i.inline.backspace").first();
            // TODO: Use Press, blocking issue on iPhone
            backspace && backspace.on("click", (e) => { 
                this.setValue(null); 
            })
        }

        this._container = QueryElement.QueryElement('div')
            .addClass("decimal")
            .addClass("popout")
            .addClass("popout-" + this.config.popout)
            .appendTo(this);

        if (this.config.salesUnitProperty !== undefined)
        {
            var salesUnits = this.getCard().Model.get(this.config.salesUnitProperty.split("."));
            var salesUnitInfo = this.getCard().ModelData.get(this.config.salesUnitProperty.split("."));

            this._salesUnits = {
                salesUnits: salesUnits,
                salesUnitNames: salesUnitInfo.info
            };

            // Add listener
            this._changedSalesUnitEvent = this.getCard().Model.changedEvent.on(data => {
                // Do not change on initialSet
                if (data.initial)
                    return;
                let property = data.path.join(".");
                if (this.config.salesUnitProperty == property && this._salesUnits != null) {
                    this.setSalesUnits(data.value);
                }
            });

            if (card.SiteConfig.salesUnitOrder.length > 0) {
                for(var item of card.SiteConfig.salesUnitOrder) {
                    let salesUnit = this._salesUnits.salesUnits
                        .filter(a => a.salesUnit == item)
                        .first();
                    
                    if (salesUnit != null) {
                        this._salesUnit = salesUnit;
                        break;
                    }
                }
            }
        }



        if (this.config.quantityProperty !== undefined)
        {
            // Add listener
            this._changedQuantityEvent = this.getCard().Model.changedEvent.on(data => {
                // Do not change on initialSet
                if (data.initial)
                    return;    
                
                // Get first item of path not equalling current path (so we make relative paths form an absolute one)
                for (var x = 0; x < Math.min(data.path.length, this.path.length); x++) {
                    if (this.path[x] != data.path[x])
                        break;
                }
                // And now join it
                let property = data.path.slice(x).join(".");
                if (this.config.quantityProperty == property) {
                    this.setValue(
                        this.getQuantityClosestValue(
                            data.value
                        )
                    );
                }
            });
        }
        if (this.config.priceProperty !== undefined)
        {
            let absolutePath = [this.path[0]]
                .concat(this.config.priceProperty.split("."));
            this._lastPrice = this.getCard().Model.get(absolutePath);

            // Add listener
            this._changedPriceEvent = this.getCard().Model.changedEvent.on(data => {
                // Do not change on initialSet
                if (data.initial)
                    return;    

                // Get first item of path not equalling current path (so we make relative paths form an absolute one)
                for (var x = 0; x < Math.min(data.path.length, this.path.length); x++) {
                    if (this.path[x] != data.path[x])
                        break;
                }
                // And now join it
                let property = data.path.slice(x).join(".");
                if (this.config.priceProperty == property) {
                    this._lastPrice = data.value;

                    this.setValue(
                        Number(this.getPriceValue(
                            data.value
                        ))
                    );
                }
            });
        }

        if (this.config.originalPriceProperty !== undefined)
        {
            this._originalPrice = this.getCard().Model.get(this.config.originalPriceProperty.split("."));
        }
    }
    init(elem: IQueryElement) {
        super.init(elem);
        this._startValue = this.getValue();
    }
    getInput() {
        return this._input;
    }
    defaultKeyDownHandler(e: KeyboardEvent) {
        switch (e.keyCode) {
            case 38: // KEY UP 
                this.moveUp();
                e.stop(); 
                break;
            case 40: // KEY DOWN 
                this.moveDown();   
                e.stop(); 
                break;    
        }

        //if (e.keyCode != 9)
        //    this.show();
        
        super.defaultKeyDownHandler(e);
    }
    show() {
        this._container.addClass("show");
    }
    unShow() {
        this._container.removeClass("show");
    }
    showToggle() {
        if (this._container.containsClass("show"))
            this.unShow();
        else
            this.show();
    }

    moveUp() {
        this.setValue(
            (this.getValue() || 0) + ((1 / Math.pow(10, this.config.decimals)) / this._salesUnit.quantity), true);
    }
    moveDown() {
        this.setValue(
            (this.getValue() || 0) - ((1 / Math.pow(10, this.config.decimals)) / this._salesUnit.quantity), true);
    }
    getPriceValue(number: number)
    {
        if (this.config.priceQuantity === undefined)
            throw "Config.PriceQuantity was not set!";

        return ((number * this.config.priceQuantity.multiplier) + this.config.priceQuantity.price)
                    .toFixed(this.config.showDecimals ?? this.config.decimals);
    }
    getQuantityClosestValue(number: number)
    {
        if (this.config.quantityArray) {
            number = Math.abs(number);// On negative switch to positive to get price

            for (let [key, value] of Object.entries(this.config.quantityArray).reverse()) {
                let keyNumber = parseInt(key);
                if (number >= keyNumber)
                    return value;    
            }
        }

        return null;
    }

    defaultConfig(): ISiteLabelDecimalConfig {
        return {
            popout: "normal",
            decimals: 0,
            scroll: "top"
        }
    }
    makeActive() {
        if(super.makeActive()) {
            if (!this.getSiteConfig().settings.includes("NoAutoPopout"))
                this.show();
            
            this._input.select();
            
            return true;
        }
        return false;
    }
    makeInactive() {
        super.makeInactive();
        this.unShow();
    }
    setSalesUnits(salesUnits: SalesUnit[]) {
        var val = this._origValue;

        let salesUnit = salesUnits
            .filter(a => a.salesUnit == this._salesUnit.salesUnit)
            .first();
        if (salesUnit != null)
            this._salesUnit = salesUnit;
        else
            this._salesUnit = SiteLabelDecimal.SALESUNIT_DEFAULT;
        
        if (this._salesUnits != null)
            this._salesUnits.salesUnits = salesUnits
        
        this.setValue(val, true);
        this.renderNumbers();
    }
    setMultiplier(salesUnit: SalesUnit) {
        var val = this._origValue;
        this._salesUnit = salesUnit;
        this.setValue(val, true);
        this.renderNumbers();
    }

    private propertyToSalesUnits(property: string) : SalesUnits
    {
        switch(property) {
            default:
                return "Piece";
            case "trolley":
                return "Trolley";
            case "layer":
                return "Layer";
            case "quantity":
                return "Quantity";
            case "bunch":
                return "Bunch";
            case "piece":
                return "Piece";
        }
    }

    renderNumbers() {
        this._container.clear();

        if (this._salesUnits != null) {
            let containerMultiplier = QueryElement.QueryElement("div").addClass("multiplier");

            for(let item in this._salesUnits.salesUnitNames) {
                let salesUnit = this._salesUnits.salesUnits.filter(a => a.salesUnit == this.propertyToSalesUnits(item)).first();

                if (this.propertyToSalesUnits(item) == "Piece")
                {
                    salesUnit = SiteLabelDecimal.SALESUNIT_DEFAULT;
                }
                
                let button = new SiteButton({
                    title: this._salesUnits.salesUnitNames[item]
                }).appendTo(containerMultiplier);

                button.removeClass("selected");
                if (salesUnit != null)
                {
                    button.on("click", a => {
                        if (salesUnit != null)
                            this.setMultiplier(salesUnit)
                    })
                    button.enable();

                    if (salesUnit.salesUnit == this._salesUnit.salesUnit)
                    {
                        button.addClass("selected");
                    }
                }
                else
                {
                    button.disable();
                }
            }
            this._container.append(containerMultiplier);
        }

        let value = (this.getValue() || 0) * this._salesUnit.quantity;
        let container = QueryElement.QueryElement("div").addClass("numbers");

        let multiplier = Math.pow(10, this.config.showDecimals ?? this.config.decimals);
        let upper = (Math.pow(10, (this.config.showDecimals ?? this.config.decimals) - this.config.decimals));

        let number = Math.round(value * Math.pow(10, this.config.decimals));
        let numberShow = Math.round(value * multiplier);

        let difference = numberShow - (number * upper);
        let startNumber = (number - (number  + (Math.abs(number) - Math.abs(number) % 5) + 5) % 5) * upper;
        let startValue = (this._startValue || 0) * multiplier;

        let fromNumber = Math.max(this.config.minValue || startNumber - (10 * upper), startNumber - (10 * upper)) + difference;
        let toNumber = Math.min(this.config.maxValue || fromNumber + (30 * upper), fromNumber + (30 * upper)) + difference;

        for(let x = fromNumber; x < toNumber; x+=upper)
        {
            let currValue = (x / multiplier);
            let button = new SiteButton({
                title: currValue.toFixed(this.config.showDecimals ?? this.config.decimals)
            }).appendTo(container);
            
            button.on("click", (e) => {
                this.setValue(currValue / this._salesUnit.quantity, true); 
                this._input.select();
                // If we stay active, rerender buttons:
                if (!this.makeNextActive())
                    this.renderNumbers();
                
                e.stop();
            });

            if(numberShow === x)
                button.addClass("selected");
            else if(x === startValue)
                button.addClass("start");
        }

        this._container.append(container);
    }

    getValue() {
        var value = this._input.getVal();
        if (value != null && value !== "")
            return Number(value.replace(",", "."))  / this._salesUnit.quantity;
        else
            return null;    
    }
    setValue(value: number | null, round: boolean = false) {
        super.setValue(value);

        if (this._percentage != null)
        {
            this._percentage.clear();
            if (value != null && value != 0)
            {
                if (this._originalPrice != null)
                {
                    let difference = value - this._originalPrice;
                    let percentage = (difference / this._originalPrice) * 100;
                    
                    var element = QueryElement.QueryElement("div");
                    element.setHtml(`${percentage.toFixed(1)}%`);
                    if (percentage > 0)
                        element.addClass("ok");
                    else
                        element.addClass("error");

                    this._percentage.append(
                        element
                    );
                }
                if (this._lastPrice != null)
                {
                    let difference = value - this._lastPrice;
                    let percentage = (difference / this._lastPrice) * 100;
                    
                    var element = QueryElement.QueryElement("div");
                    element.setHtml(`${percentage.toFixed(1)}%`);
                    if (percentage > 0)
                        element.addClass("ok");
                    else
                        element.addClass("error");

                    this._percentage.append(
                        element
                    );
                }
            }
        }

        this._origValue = value;

        if(this._origValue === null) {
            this._input.setVal("");
        }
        else {
            let value = this._origValue * this._salesUnit.quantity;
            this._input.setVal(
                (round 
                    ? Math.roundPlaces(value, this.config.showDecimals ?? this.config.decimals)
                    : value).toString()
            );
        }
        
        this.renderNumbers();
    } 
}